import * as angular from "angular";
import * as _ from "lodash";

export class OrganizationsDialogService {

  constructor(private $mdDialog, private uploadFile, private $log) {
  }

  createOrganization(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/set-organization-dialog.html').default,
      controller: function ($scope) {
        $scope.loading = false;
        $scope.logoStatus = 'idle';
        $scope.header = 'Create Organization';

        $scope.organization = {
          name: undefined,
          enabled: true
        };

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.organization);
            }

          }
        }

        $scope.onLogoUpload = ($files) => {
          $scope.logoStatus = 'upload';
          self.uploadFile($files[0])
            .then((response) => {
              $scope.logoStatus = 'complete';
              $scope.organization.logoUrl = _.get(response, 'data.url');
            })
            .catch((error) => {
              if (error) {
                $scope.logoStatus = 'idle';
                $scope.organization.logoUrl = undefined;
                self.$log.error('Failed to upload file, agentDialogService@uploadDocuments@uploadMvr', error);
              }
            })
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


  editOrganizationInfo(event, organization) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/set-organization-dialog.html').default,
      controller: function ($scope) {
        $scope.loading = false;
        $scope.logoStatus = 'idle';
        $scope.header = 'Update Organization';

        $scope.organization = angular.copy(organization);

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.organization);
            }

          }
        }


        $scope.onLogoUpload = ($files) => {
          $scope.logoStatus = 'upload';
          self.uploadFile($files[0])
            .then((response) => {
              $scope.logoStatus = 'complete';
              $scope.organization.logoUrl = _.get(response, 'data.url');
            })
            .catch((error) => {
              if (error) {
                $scope.logoStatus = 'idle';
                $scope.organization.logoUrl = undefined;
                self.$log.error('Failed to upload file, agentDialogService@uploadDocuments@uploadMvr', error);
              }
            })
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })

  }

}

angular
  .module('bringoz.admin.organizations')
  .service('organizationsDialogService', OrganizationsDialogService);
